
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/46-percent-caasp-growth-ca",
      function () {
        return require("private-next-pages/c/blog-posts/46-percent-caasp-growth-ca.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/46-percent-caasp-growth-ca"])
      });
    }
  